import React from "react";
import { NaturalPersonForm, QuestionaryForm } from "@/components";
import { getUser } from "@/utils/localStorage.tsx";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { RootState, useAppDispatch, useAppSelector } from "@/store";
import { setActiveTab } from "@/store/slices/componentSlice";
import AdminCurrescy from "@/components/AdminCurrescy";
import Groups from "./Groups";
import BankSettingsAdmin from "./BankSettingsAdmin";
import { ClientAccess, ClientSettings } from "@/pages/index.tsx";
import BankCryptoManagement from "./BankSettingsRedo";
import BusinessInfoFormNEW from "@/components/AccountForms/BusinessInfoNEW";
import { useSelector } from "react-redux";
import { isBitramp } from "@/utils/utils";

const Settings: React.FC = () => {
  const user = getUser();

  const isAdmin = user?.is_superuser;
  const isStaff = user?.is_staff;
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector((state) => state.component);

  const { selectedClient } = useSelector((state: RootState) => state.client);

  return selectedClient?.id ? (
    <ClientSettings client_settings_id={selectedClient?.id} />
  ) : (
    <div className="settings mb-12">
      <div className="settings__right">
        <div className="settings__right--flex"></div>
        {isAdmin ? (
          <div className="settings__container">
            <div className="w-full justify-between items-center flex px-8">
              <h1 className="Heading2 bold dark-blue">Settings</h1>
            </div>
            <Tabs
              selectedIndex={activeTab}
              onSelect={(idx) => {
                dispatch(setActiveTab(idx));
              }}
            >
              <TabList className="flex gap-2 justify-between rounded-t-[0.645rem]">
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2b2b2b] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Crypto Add
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2b2b2b] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Group Settings
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2b2b2b] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Client Access
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2b2b2b] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Platform account
                </Tab>
              </TabList>

              <TabPanel>
                <AdminCurrescy />
              </TabPanel>
              <TabPanel>
                <Groups />
              </TabPanel>
              <TabPanel>
                <ClientAccess />
              </TabPanel>
              <TabPanel>
                <BankSettingsAdmin />
              </TabPanel>
            </Tabs>
          </div>
        ) : isStaff ? (
          <div className="settings__container">
            <div className="w-full justify-between items-center flex">
              <h1 className="settings__container__title">Settings</h1>
            </div>
            <Tabs
              selectedIndex={activeTab}
              onSelect={(idx) => {
                dispatch(setActiveTab(idx));
              }}
            >
              <TabList className="flex gap-2 justify-between rounded-t-[0.645rem]">
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Crypto Add
                </Tab>

                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Platform account
                </Tab>
              </TabList>

              <TabPanel>
                <AdminCurrescy />
              </TabPanel>

              <TabPanel>
                <BankSettingsAdmin />
              </TabPanel>
            </Tabs>
          </div>
        ) : (
          <div>
            <Tabs
              selectedIndex={activeTab}
              onSelect={(idx) => {
                dispatch(setActiveTab(idx));
              }}
            >
              <TabList className="flex gap-2 justify-between rounded-t-[0.645rem]">
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Business Info
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Individual
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Questionnaire
                </Tab>
                <Tab
                  className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                    isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                  } flex justify-center items-center mb-2`}
                  selectedClassName={`${
                    isBitramp()
                      ? "!bg-[#2B2B2B] !text-white"
                      : "!bg-[#fff] !text-[#111b31]"
                  }  !font-[600] !mb-0 !rounded-b-[0rem]`}
                >
                  Bank account and wallet
                </Tab>
              </TabList>

              <TabPanel>
                <BusinessInfoFormNEW />
              </TabPanel>
              <TabPanel>
                <NaturalPersonForm />
                {/* <BusinessInfoForm /> */}
              </TabPanel>
              <TabPanel>
                <QuestionaryForm />
              </TabPanel>
              <TabPanel>
                <BankCryptoManagement />
              </TabPanel>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
